export default "__VITE_ASSET__Bvwywd2p__"